
<script>
import CustomField from "./vuetable-field-custom";

export default {
    name: "VuetableFieldCompany",
    extends: CustomField
}
</script>
